import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgCreditCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M18 6V4H2v2zm0 4H2v6h16zM0 4c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm4 8h4v2H4z"
      fill="currentColor"
    />
  </svg>
);
